import React, { createContext, useMemo } from 'react';
import { DataItem } from '../../scanDataApi/context/ScanDataContext';
import { CustomerSummary } from '../customerSummary';
import { useGetCustomerSummaryInfo } from '../hooks/useGetCustomerSummaryInfo';

export interface CustomerSummaryState {
  customerSummary: DataItem<CustomerSummary[]>;
}

interface CustomerSummaryProviderProps {
  children: React.ReactNode;
}

// Create the context
export const CustomerSummaryContext = createContext<
  CustomerSummaryState | undefined
>(undefined);

// Create the provider
export const CustomerSummaryProvider: React.FC<
  CustomerSummaryProviderProps
> = ({ children }) => {
  // Fetch the customer summary from cube each time the customer dropdown changes
  const cubeResultsCustomerSummary = useGetCustomerSummaryInfo();

  const customerSummary = useMemo(() => {
    return {
      data: cubeResultsCustomerSummary?.validatedData ?? null,
      isLoading: cubeResultsCustomerSummary?.isLoading ?? false,
      error: cubeResultsCustomerSummary?.error ?? null,
    };
  }, [cubeResultsCustomerSummary]);

  const value = {
    customerSummary,
  };

  return (
    <CustomerSummaryContext.Provider value={value}>
      {children}
    </CustomerSummaryContext.Provider>
  );
};
